<template>
	<div class="container">
		<div class="form_box"
			data-aos="fade-in"
			data-aos-duration="400"
			data-aos-delay="100"
			data-aos-offset="0"
			data-aos-once="true"
		>
			<div class="form_box_el">
				<div class="form_el form_left">
					<div class="label">First name<span>*</span></div>
					<div class="input_el">
						<input v-model="firstVal" :class="isClick && !firstVal ? 'err' : ''" />
					</div>
					<div v-show="isClick && !firstVal" class="error">Please complete this required field.</div>
				</div>
				<div style="width: 4%;"></div>
				<div class="form_el form_right">
					<div class="label">Last name<span>*</span></div>
					<div class="input_el">
						<input v-model="lastVal" :class="isClick && !lastVal ? 'err' : ''" />
					</div>
					<div v-show="isClick && !lastVal" class="error">Please complete this required field.</div>
				</div>
			</div>
			<div class="form_box_el">
				<div class="form_el form_left">
					<div class="label">Organization</div>
					<div class="input_el">
						<input v-model="organizationVal" class="" />
					</div>
				</div>
				<div style="width: 4%;"></div>
				<div class="form_el form_right">
					<div class="label">Title</div>
					<div class="input_el">
						<input v-model="titleVal" class="" />
					</div>
				</div>
			</div>
			<div class="form_el">
				<div class="label">Email<span>*</span></div>
				<div class="input_el">
					<input v-model="emailVal" :class="isClick && !emailVal ? 'err' : ''" />
				</div>
				<div v-show="isClick && !emailVal" class="error">Please complete this required field.</div>
			</div>
			<div class="form_el">
				<div class="label">Phone number</div>
				<div class="input_el">
					<input v-model="phoneVal" class="" />
				</div>
			</div>
			<div class="form_el">
				<div class="label">{{ title }}</div>
				<div class="input_el">
					<textarea v-model="helpVal" class="" style="height: 80px;line-height: 20px;"></textarea>
				</div>
			</div>
			<div class="form_el">
				<div class="label">How did you hear about us?<span>*</span></div>
				<div class="input_el">
					<!-- <input v-model="aboutVal" class="" /> -->
					<select v-model="aboutVal" :class="isClick && !aboutVal ? 'err' : ''">
						<option value="Google Search">Google Search</option>
						<option value="Linkedin">Linkedin</option>
						<option value="Press Article">Press Article</option>
						<option value="Referral">Referral</option>
						<option value="Email">Email</option>
						<option value="Other">Other</option>
					</select>
				</div>
				<div v-show="isClick && !aboutVal" class="error">Please select an option from the dropdown menu.</div>
			</div>
			<div class="form_el">
				<div class="label">Products you want to know</div>
				<div class="input_el">
					<textarea v-model="products" class="" style="height: 80px;line-height: 20px;"></textarea>
				</div>
			</div>
			<div v-show="isClick && !lastVal && !firstVal && !emailVal && !aboutVal" class="tips_box">
				<div class="error">Please complete all required fields.</div>
			</div>
			<div class="btn_box" @click="subClick">{{ submitTit }}</div>
		</div>
	</div>
</template>

<script>
import { formSubmit } from '@/api/public';
export default {
	props: ["leixing", "titleText"],
	components:{
		//
	},
	data() {
		return {
			emailVal: '',
			firstVal: '',
			lastVal: '',
			organizationVal: '',
			titleVal: '',
			phoneVal: '',
			helpVal: '',
			aboutVal: '',
			products: '',
			isClick: false,
			type: this.leixing,
			submit: this.titleText,
			title: 'How can we help you today?',
			formType: 'Contact Us',
			submitTit: 'Subscribe',
		}
	},
	created(){
		let that = this;
		if(that.type) {
			that.title = 'What would you like to discuss at '+ that.type +'?';
			that.formType = that.type;
		}
		if(that.submit) {
			that.submitTit = that.submit;
		}
		if(that.$route.query.products) {
			that.products = that.$route.query.products.split('-')[0] + '(' + that.$route.query.products.split('-')[1] + ')';
		}
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//点击提交
		subClick() {
			let that = this;
			that.isClick = true;
			if(that.emailVal && that.firstVal && that.lastVal && that.aboutVal) {
				that.$toast.loading({
					forbidClick: true,
				});
				formSubmit({
					first_name: that.firstVal,
					last_name: that.lastVal,
					organization: that.organizationVal,
					title: that.titleVal,
					email: that.emailVal,
					phone_number: that.phoneVal,
					content: that.helpVal,
					source: that.aboutVal,
					type: that.formType,
					product_name: that.products
				}).then(res => {
					that.$toast.clear();
					that.$toast('Your form has been successfully submitted, thank you!');
					that.emailVal = '';
					that.firstVal = '';
					that.lastVal = '';
					that.organizationVal = '';
					that.titleVal = '';
					that.phoneVal = '';
					that.helpVal = '';
					that.aboutVal = '';
					that.products = '';
					that.isClick = false;
				});
			}
		},
	}
}
</script>

<style lang="less" scoped>
.form_box{
	.btn_box{
		display: inline-block;
		margin-top: 30px;
		padding: 6px 20px;
		background: #0B318F;
		border-color: #0B318F;
		color: #ffffff;
		//font-weight: bold;
		font-family: helvetica;
		cursor: pointer;
	}
	.tips_box{
		margin-top: 20px;
		.error{
			font-size: 13px;
			font-family: helvetica;
			color: #f2545b;
		}
	}
	.form_box_el{
		display: flex;
		.form_left{
			flex: 1;
		}
		.form_right{
			flex: 1;
		}
	}
	.form_el{
		width: 100%;
		margin-top: 15px;
		.input_el{
			input, textarea, select{
				width: 100%;
				height: 40px;
				line-height: 40px;
				padding: 9px 10px;
				background-color: #f5f8fa;
				color: #33475b;
				border: 1px solid #cbd6e2;
			}
			input.err{
				border: 1px solid #c87872;
			}
			select.err{
				border: 1px solid #c87872;
			}
		}
		.label{
			font-size: 13px;
			font-family: helvetica;
			color: #0B318F;
			span{
				color: #f2545b;
			}
		}
		.error{
			font-size: 13px;
			font-family: helvetica;
			color: #f2545b;
		}
	}
}
</style>